
// ROUTES
require('modules/wiki/routes/wiki');

// CONTROLLERS
require('modules/wiki/controllers/wiki');
require('modules/wiki/controllers/list');
require('modules/wiki/controllers/create');
require('modules/wiki/controllers/edit');
require('modules/wiki/controllers/detail');

// SERVICES
require('modules/wiki/services/wiki');
require('modules/wiki/services/list');
require('modules/wiki/services/create');
require('modules/wiki/services/edit');
require('modules/wiki/services/delete');


angular.module('unica_wiki', [

	// ROUTES
	'unica_wiki.wiki_routes',

	// CONTROLLERS
	'unica_wiki.wiki_controllers',

	// SERVICES
	'unica_wiki.wiki_services'

]);